import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "text-xs font-bold"
};
const _hoisted_2 = { class: "max-w-[75%] sm:max-w-[80%] lg:max-w-[75%]" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
    key: 2,
    class: "mt-1 flex items-center justify-end gap-2 px-1 text-[11px] text-red-500"
};
import { computed } from 'vue';
import { IconRefresh, IconUser } from '@tabler/icons-vue';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import DraftCard from './DraftCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatMessage',
    props: {
        message: {},
        isStreaming: { type: Boolean, default: false },
        canCreateItineraries: { type: Boolean, default: true }
    },
    emits: ["open-draft", "retry"],
    setup(__props) {
        marked.setOptions({ breaks: true, gfm: true });
        const props = __props;
        const isUser = computed(() => props.message.role === 'user');
        const bubbleClasses = computed(() => isUser.value
            ? 'bg-white border border-gray-200 text-gray-800 rounded-2xl rounded-br-md'
            : 'bg-gray-100 text-gray-800 rounded-2xl rounded-bl-md');
        const renderedContent = computed(() => {
            const raw = marked.parse(props.message.content);
            return DOMPurify.sanitize(raw);
        });
        const formattedTime = computed(() => {
            const d = props.message.timestamp;
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["flex items-end gap-2", isUser.value ? 'flex-row-reverse' : 'flex-row'])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center", isUser.value ? 'bg-eblue-100 text-eblue-500' : 'bg-eorange-100 text-eorange-500'])
                }, [
                    (isUser.value)
                        ? (_openBlock(), _createBlock(_unref(IconUser), {
                            key: 0,
                            size: 16
                        }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_1, "E"))
                ], 2),
                _createElementVNode("div", _hoisted_2, [
                    (isUser.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap break-words", bubbleClasses.value])
                        }, _toDisplayString(__props.message.content), 3))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (__props.isStreaming && !__props.message.content)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["px-4 py-3", bubbleClasses.value])
                                }, [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("div", { class: "flex gap-1" }, [
                                            _createElementVNode("span", {
                                                class: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                                                style: { "animation-delay": "0ms" }
                                            }),
                                            _createElementVNode("span", {
                                                class: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                                                style: { "animation-delay": "150ms" }
                                            }),
                                            _createElementVNode("span", {
                                                class: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                                                style: { "animation-delay": "300ms" }
                                            })
                                        ], -1)
                                    ]))], 2))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["chat-markdown px-4 py-3 text-sm leading-relaxed break-words", bubbleClasses.value]),
                                    innerHTML: renderedContent.value
                                }, null, 10, _hoisted_3))
                        ], 64)),
                    (isUser.value && __props.message.status === 'failed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("chatbot.auto.message_failed")), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center gap-1 rounded-md border border-red-200 bg-white px-2 py-1 font-medium text-red-600 hover:bg-red-50",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('retry', __props.message.content)))
                            }, [
                                _createVNode(_unref(IconRefresh), { size: 12 }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("chatbot.auto.retry")), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (__props.message.draft && __props.canCreateItineraries)
                        ? (_openBlock(), _createBlock(DraftCard, {
                            key: 3,
                            draft: __props.message.draft,
                            onOpenDraft: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('open-draft', $event)))
                        }, null, 8, ["draft"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("p", {
                        class: _normalizeClass(["text-[10px] text-gray-400 mt-1 px-1", isUser.value ? 'text-right' : 'text-left'])
                    }, _toDisplayString(formattedTime.value), 3)
                ])
            ], 2));
        };
    }
});
